export default __webpack_public_path__ + "static/media/IMG4.f1a332ed.jpg";